<template>
<div>
	<b-row v-if="weekData.length > 1">
		<b-col>
			<div class="slot-container">
				<ul>
					<li class="slotColHeader"><div class="border p-3 slotColHeaderInner" >{{ weekData[0][0].day }}</div></li>
						
						<li v-for="(slot, index) in weekData[0]" :key="slot.id">
							<div class="border p-3" :class="selectAll[0].class"><span :class="getCheckedClass(slot.time_status)">{{ slot.slot_time}}</span><br />
								<input type="checkbox" :id="slot.id" :class="[week, 'dayOne']" :checked="getCheckedState(slot.time_status)" @click="selectDayCheckBox(index, weekData[0], 0)"/>
							</div>
						</li>
					
					<li class="p-1"><b-button block :variant="getSelectAllButtonClass(0)" size="sm" @click="selectAllDayCheckBoxes(weekData[0], week, 'dayOne', 0)"><span class="" :class="selectAll[0].spinnerText">{{ getSelectAllText(0) }}</span><span :class="selectAll[0].spinner" ><b-spinner small ></b-spinner> Saving...</span></b-button></li>
					<li class="px-1"><b-button block :variant="selectAll[0].updateButtonClass" size="sm" :disabled="selectAll[0].disabled" @click="updateDay(weekData[0], 0)"> Update</b-button></li>
				</ul>
			</div>
		</b-col>
		<b-col>
			<div class="slot-container">
				<ul>
					<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ weekData[1][0].day  }}</div></li>
		
					<li v-for="(slot, index) in weekData[1]" :key="slot.id">
						<div class="border p-3" :class="selectAll[1].class"><span :class="getCheckedClass(slot.time_status)">{{ slot.slot_time}}</span><br />
							<input type="checkbox" :id="slot.id" :class="[week, 'dayTwo']" :checked="getCheckedState(slot.time_status)" @click="selectDayCheckBox(index, weekData[1], 1)"/>
						</div>
					</li>
					
					<li class="p-1"><b-button block :variant="getSelectAllButtonClass(1)" size="sm" @click="selectAllDayCheckBoxes(weekData[1], week, 'dayTwo', 1)"><span class="" :class="selectAll[1].spinnerText">{{ getSelectAllText(1)}}</span><span :class="selectAll[1].spinner" ><b-spinner small ></b-spinner> Saving...</span></b-button></li>
					<li class="px-1"><b-button block :variant="selectAll[1].updateButtonClass" size="sm" :disabled="selectAll[1].disabled" @click="updateDay(weekData[1], 1)">Update</b-button></li>
				</ul>
			</div>
		</b-col>
		<b-col>
			<div class="slot-container">
				<ul>
					<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ weekData[2][0].day   }}</div></li>
		
					<li v-for="(slot, index) in weekData[2]" :key="slot.id">
						<div class="border p-3" :class="selectAll[2].class"><span :class="getCheckedClass(slot.time_status)">{{ slot.slot_time}}</span><br />
							<input type="checkbox" :id="slot.id" :class="[week, 'dayThree']" :checked="getCheckedState(slot.time_status)" @click="selectDayCheckBox(index, weekData[2], 2)"/>
						</div>
					</li>
					
					<li class="p-1"><b-button block :variant="getSelectAllButtonClass(2)" size="sm" @click="selectAllDayCheckBoxes(weekData[2], week, 'dayThree', 2)"><span class="" :class="selectAll[2].spinnerText">{{ getSelectAllText(2)}}</span><span :class="selectAll[2].spinner" ><b-spinner small ></b-spinner> Saving...</span></b-button></li>
					<li class="px-1"><b-button block :variant="selectAll[2].updateButtonClass" size="sm" :disabled="selectAll[2].disabled" @click="updateDay(weekData[2], 2)">Update</b-button></li>
				</ul>
			</div>
		</b-col>
		<b-col>
			<div class="slot-container">
				<ul>
					<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ weekData[3][0].day  }}</div></li>
		
					<li v-for="(slot, index) in weekData[3]" :key="slot.id">
						<div class="border p-3" :class="selectAll[3].class"><span :class="getCheckedClass(slot.time_status)">{{ slot.slot_time}}</span><br />
							<input type="checkbox" :id="slot.id" :class="[week, 'dayFour']" :checked="getCheckedState(slot.time_status)" @click="selectDayCheckBox(index, weekData[3], 3)"/>
						</div>
					</li>
					
					<li class="p-1"><b-button block :variant="getSelectAllButtonClass(3)" size="sm" @click="selectAllDayCheckBoxes(weekData[3], week, 'dayFour', 3)"><span class="" :class="selectAll[3].spinnerText">{{ getSelectAllText(3)}}</span><span :class="selectAll[3].spinner" ><b-spinner small ></b-spinner> Saving...</span></b-button></li>
					<li class="px-1"><b-button block :variant="selectAll[3].updateButtonClass" size="sm"  :disabled="selectAll[3].disabled" @click="updateDay(weekData[3], 3)">Update</b-button></li>
				</ul>
			</div>
		</b-col>
		<b-col>
			<div class="slot-container">
				<ul>
					<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ weekData[4][0].day  }}</div></li>
		
					<li v-for="(slot, index) in weekData[4]" :key="slot.id">
						<div class="border p-3" :class="selectAll[4].class"><span :class="getCheckedClass(slot.time_status)">{{ slot.slot_time}}</span><br />
							<input type="checkbox" :id="slot.id" :class="[week, 'dayFive']" :checked="getCheckedState(slot.time_status)" @click="selectDayCheckBox(index, weekData[4], 4)"/>
						</div>
					</li>
					
					<li class="p-1"><b-button block :variant="getSelectAllButtonClass(4)" size="sm" @click="selectAllDayCheckBoxes(weekData[4], week, 'dayFive', 4)"><span class="" :class="selectAll[4].spinnerText">{{ getSelectAllText(4)}}</span><span :class="selectAll[4].spinner" ><b-spinner small ></b-spinner> Saving...</span></b-button></li>
					<li class="px-1"><b-button block :variant="selectAll[4].updateButtonClass" size="sm" :disabled="selectAll[4].disabled" @click="updateDay(weekData[4], 4)">Update</b-button></li>
				</ul>
			</div>
		</b-col>
		<b-col>
			<div class="slot-container">
				<ul>
					<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ weekData[5][0].day  }}</div></li>
		
					<li v-for="(slot, index) in weekData[5]" :key="slot.id">
						<div class="border p-3" :class="selectAll[5].class"><span :class="getCheckedClass(slot.time_status)">{{ slot.slot_time}}</span><br />
							<input type="checkbox" :id="slot.id" :class="[week, 'daySix']" :checked="getCheckedState(slot.time_status)" @click="selectDayCheckBox(index, weekData[5], 5)"/>
						</div>
					</li>
					
					<li class="p-1"><b-button block :variant="getSelectAllButtonClass(5)" size="sm" @click="selectAllDayCheckBoxes(weekData[5], week, 'daySix', 5)"><span class="" :class="selectAll[5].spinnerText">{{ getSelectAllText(5)}}</span><span :class="selectAll[5].spinner" ><b-spinner small ></b-spinner> Saving...</span></b-button></li>
					<li class="px-1"><b-button block :variant="selectAll[5].updateButtonClass" size="sm"  :disabled="selectAll[5].disabled" @click="updateDay(weekData[5], 5)">Update</b-button></li>
				</ul>
			</div>
		</b-col>
		<b-col>
			<div class="slot-container">
				<ul>
					<li class="slotColHeader"><div class="border p-3 slotColHeaderInner">{{ weekData[6][0].day }}</div></li>
		
					<li v-for="(slot, index) in weekData[6]" :key="slot.id">
						<div class="border p-3" :class="selectAll[6].class"><span :class="getCheckedClass(slot.time_status)">{{ slot.slot_time}}</span><br />
							<input type="checkbox" :id="slot.id" :class="[week, 'daySeven']" :checked="getCheckedState(slot.time_status)" @click="selectDayCheckBox(index, weekData[6], 6)"/>
						</div>
					</li>
					
					<li class="p-1"><b-button block :variant="getSelectAllButtonClass(6)" size="sm" @click="selectAllDayCheckBoxes(weekData[6], week, 'daySeven', 6)"><span class="" :class="selectAll[6].spinnerText">{{ getSelectAllText(6)}}</span><span :class="selectAll[6].spinner" ><b-spinner small ></b-spinner> Saving...</span></b-button></li>
					<li class="px-1"><b-button block :variant="selectAll[6].updateButtonClass" size="sm"  :disabled="selectAll[6].disabled" @click="updateDay(weekData[6], 6)">Update</b-button></li>
				</ul>
			</div>
		</b-col>
	</b-row>
</div>
</template>

<script>
import {RepositoryFactory} from '../api/RepositoryFactory'
import {mixin} from '../mixins/clickAndCollectMixins'
import $ from 'jquery'
const SlotsRepoPost = RepositoryFactory.post('slots')
//var $ = require('jquery')
export default{
	name: 'CorehoursSlotsGridConfigure',
	props: ['slots', 'admin', 'week', 'weekData'],
	mixins: [mixin],
	data(){
		return{
			selectAll: [
				{id: 0, text: "Close All", class : 'open', disabled : 'disabled', updateButtonClass : 'outline-secondary', selectButtonClass : 'outline-success', spinner : 'd-none', spinnerText : ''},
				{id: 1, text: "Close All", class : 'open', disabled : 'disabled', updateButtonClass : 'outline-secondary', selectButtonClass : 'outline-success', spinner : 'd-none', spinnerText : ''},
				{id: 2, text: "Close All", class : 'open', disabled : 'disabled', updateButtonClass : 'outline-secondary', selectButtonClass : 'outline-success', spinner : 'd-none', spinnerText : ''},
				{id: 3, text: "Close All", class : 'open', disabled : 'disabled', updateButtonClass : 'outline-secondary', selectButtonClass : 'outline-success', spinner : 'd-none', spinnerText : ''},
				{id: 4, text: "Close All", class : 'open', disabled : 'disabled', updateButtonClass : 'outline-secondary', selectButtonClass : 'outline-success', spinner : 'd-none', spinnerText : ''},
				{id: 5, text: "Close All", class : 'open', disabled : 'disabled', updateButtonClass : 'outline-secondary', selectButtonClass : 'outline-success', spinner : 'd-none', spinnerText : ''},
				{id: 6, text: "Close All", class : 'open', disabled : 'disabled', updateButtonClass : 'outline-secondary', selectButtonClass : 'outline-success', spinner : 'd-none', spinnerText : ''},
			],
			selectAllWeekText : "Close All",
			timeStatus: ""
		}
	},
	created()
	{
		console.log(this.weekData)		
	},
	methods: {	
		setSlotText(slotStatus)
		{
			return (slotStatus == 'Enabled')? 'open' : 'closed'
		},
		getCheckedState(slotStatus)
		{
			let checkedState = (slotStatus == 'Enabled')? true : false			
			return checkedState
		},
		async updateDay(slots, index){
			console.log(slots)
			console.log(index)
			var payload = new FormData();
			var payloadData = this.weekData[index];
			payload.append('payload', JSON.stringify(payloadData));
			payload.append('updateType', slots[0]['slot_type']) // this should always be 0 as there will always be at least one slot for any day
			payload.append('corePeriod', slots[0]['day']) // this should always be 0 as there will always be at least one slot for any day
			payload.append('storeId', this.$store.state.storeId) // this should always be 0 as there will always be at least one slot for any day
			await SlotsRepoPost.postUpdateCoreHours(payload)
			
			this.selectAll[index].spinner = ''
			this.selectAll[index].spinnerText = 'd-none'				
			this.selectAll[index].disabled = 'disabled'
			setTimeout(() => {
				this.selectAll[index].spinner = 'd-none'
				this.selectAll[index].spinnerText = ''		
			}, 4500)		
			
		},
		getCheckedClass(slotStatus)
		{
			let checkedClass = (slotStatus == 'Enabled')? 'open' : 'closed'
			return checkedClass
		},
		selectDayCheckBox(index, slots, dayIndex)
		{			
			slots[index].time_status = (slots[index].time_status == 'Enabled')? 'closed' : 'Enabled'
			this.selectAll[dayIndex].disabled = false;
			this.selectAll[dayIndex].updateButtonClass = 'primary'
		},
		selectAllWeekCheckBoxes(week)
		{
			let checkboxClass = week
			if(this.selectAllWeekText == 'Close All')
			{
				$('.'+checkboxClass).prop('checked', false)
				this.selectAllWeekText = 'Open All'
				this.selectAll.map( day =>{
					day.text = 'Open All'
				})	
			
			}
			else
			{
				$('.'+checkboxClass).prop('checked', true)
				this.selectAllWeekText = 'Close All'
				this.selectAll.map( day =>{
					day.text = 'Close All'
				})	
				this.selectAll.map(slot =>{
					slot.class = 'closed'						
				})					
			}

		},
		selectAllDayCheckBoxes(weekData, day, week, index)
		{
			console.log(weekData)
			console.log(day)
			console.log(week)
			console.log(index)
			
			let checkboxClass = week + '.' + day
			
			if(this.selectAll[index].text == 'Close All')
			{
				this.selectAll[index].text = 'Open All'
				$('.'+checkboxClass).prop('checked', false)
				this.timeStatus = 'closed'
				this.selectAll[index].class = "closed"
				this.selectAll[index].selectButtonClass = "outline-success"
			}
			else
			{
				this.selectAll[index].text = 'Close All'
				$('.'+checkboxClass).prop('checked', true)
				this.timeStatus = 'Enabled'
				this.selectAll[index].class = "open"
				this.selectAll[index].selectButtonClass = "outline-danger"
			}

			weekData.map(slot =>{
				slot.time_status = this.timeStatus			
			})

			this.$nextTick().then(() => {
				this.selectAll[index].Text = (this.selectAll[index] ==  "Open All")? "Close All" : "Open All"
				console.log(weekData)
							
			});
			this.selectAll[index].updateButtonClass = 'primary'
			this.selectAll[index].disabled = false;
		},
		getSelectAllText(index){
			let slotText = 'Close All'
			
			let sum = 0;
			//console.log(this.slots)
			var slotsArray = this.weekData[index]
			//console.log(slotsArray)
			for (var slot in slotsArray) {
			//	console.log(slot)
				if(slot['time_status'] == 'closed')
				sum += 1;
			}

			slotsArray.map(slot=>{
			if(slot['time_status'] == 'closed')
				sum += 1;
			})

			if(sum >= 1)
			{
				slotText = 'Open All'
			}

			return slotText
		},
		getSelectAllButtonClass(index){
			let slotClass = 'outline-danger'
			let sum = 0;
			//console.log(this.slots)
			var slotsArray = this.weekData[index]
		//	console.log(slotsArray)
			for (var slot in slotsArray) {
			//	console.log(slot)
				if(slot['time_status'] == 'closed')
				sum += 1;
			}

			slotsArray.map(slot=>{
			if(slot['time_status'] == 'closed')
				sum += 1;
			})

			if(sum >= 1)
			{
				slotClass = 'outline-success'
			}

			return slotClass
		}
	},
	computed:{
		coreSlotData: function(){
			
			return this.weekData
		}
	}
}
</script>

<style scoped>
.col {
    padding: 0px
}
.slotColHeaderInner{
font-weight: bold;
}
li{
font-size: 0.6em;
line-height: 1.2;
}

.p-3 {
 padding: .5rem !important; 
}

.closed, .dayClosed .open{
color: red;
}

.open, .dayOpen .open{
color: #12c112;
}
.Available{
color: white;
background-color: green
}

.Unavailable{
color: white;
background-color: red
}

.Unavailable.closed{
background-color: #c0c0c0
}

ul{
padding-inline-start: 0px;
}
li{
list-style-type:none
}

div.scrollmenu {
  background-color: #333;
  overflow: auto;
  white-space: nowrap;
}

div.scrollmenu a {
  display: inline-block;
  color: white;
  text-align: center;
  padding: 14px;
  text-decoration: none;
}

div.scrollmenu a:hover {
  background-color: #777;
}
</style>
